export const prepareVideoFileForUpload = async (videoUrl: string) => {
  const urlParts = videoUrl.split('/');
  const fileName = urlParts[urlParts.length - 1];
  const extension = fileName.split('.').pop()?.toLowerCase() || 'mp4';

  const response = await fetch(videoUrl);
  const blob = await response.blob();
  const file = new File([blob], fileName, { type: blob.type });

  return {
    file,
    fileName,
    extension,
  };
};
